<div class="test-manage">
	<div class="row">
		<div class="colstat colstat-big pad-btns">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="active"
				optionsListName="active_all_opts"
			/>
		</div>
	</div>
	<app-table-wrap
		[fieldsArr]="upperFieldsTh"
		[isStriped]="false"
	>
		<!--test_id,sub_test_id,test_association,short_name,-->
		<ng-container
			*ngTemplateOutlet="
				rowFields;
				context: { curRow: newTest, isNewRow: true }
			"
		/>
		@for (test of topTests; track test) {
			@if (active === "-1" || test.active == active) {
				<ng-container
					*ngTemplateOutlet="
						rowFields;
						context: {
							curRow: test,
							is_documented: $safeNavigationMigration(test?.is_documented),
							isTop: true,
						}
					"
				/>

				@if (test?.tests?.length) {
					@for (subTest of test.tests; track subTest) {
						@if (active === "-1" || subTest.active == active) {
							<ng-container
								*ngTemplateOutlet="
									rowFields;
									context: {
										curRow: subTest,
										is_documented: $safeNavigationMigration(
											test?.is_documented
										),
									}
								"
							/>
						}
					}
				}
			}
		}
	</app-table-wrap>
</div>

<ng-template
	#rowFields
	let-curRow="curRow"
	let-isNewRow="isNewRow"
	let-is_documented="is_documented"
	let-isTop="isTop"
>
	@if (isTop && !isNewRow) {
		<tr>
			<td
				colspan="10"
				style="height: 10px"
			></td>
		</tr>
	}

	<tr
		[class.new-row]="isNewRow"
		(click)="curRow.isExpanded = true"
	>
		@if (eventsService.isMobile) {
			<td class="action-fields">
				<button
					(click)="
						$event.stopImmediatePropagation();
						curRow.isExpanded = !curRow.isExpanded
					"
					class="btn btn-icon"
					[icon]="curRow.isExpanded ? 'narrow' : 'expand'"
					titleLang="expand"
				></button>
			</td>
		}

		@for (fieldName of upperFields; track fieldName) {
			<td
				[class.actions]="fieldName == 'action'"
				[class.name-td]="fieldName == 'name'"
				[class.child-tr]="fieldName == 'name' && !isTop && !isNewRow"
			>
				<ng-container
					*ngTemplateOutlet="
						fieldTypes;
						context: {
							curRow: curRow,
							is_documented: is_documented,
							isTop: isTop,
							isNewRow: isNewRow,
							fieldName: fieldName,
						}
					"
				></ng-container>
			</td>
		}
	</tr>
	@if (eventsService.isMobile && curRow.isExpanded) {
		<tr>
			<td colspan="9999999">
				<div class="expanded-div">
					@for (fieldName of mobileFields; track fieldName) {
						<div>
							<label>{{ fieldName | langVal }}</label>
							<ng-container
								*ngTemplateOutlet="
									fieldTypes;
									context: {
										curRow: curRow,
										is_documented: is_documented,
										isTop: isTop,
										isNewRow: isNewRow,
										fieldName: fieldName,
									}
								"
							></ng-container>
						</div>
					}
				</div>
			</td>
		</tr>
	}
</ng-template>

<ng-template
	#fieldTypes
	let-fieldName="fieldName"
	let-isNewRow="isNewRow"
	let-is_documented="is_documented"
	let-isTop="isTop"
	let-curRow="curRow"
>
	@switch (fieldName) {
		@case ("name") {
			<app-gen-input
				#firstField
				fieldName="name"
				[actualObj]="curRow"
				[errors]="curRow.errors"
				[disabled]="curRow.is_locked == 'yes' || curRow.public == 'yes'"
				(keyupEvent)="validateEntireForm()"
				(changeEvent)="
					isNewRow ? validateEntireForm() : validateField(curRow, 'name')
				"
			/>
		}

		@case ("patient_sign_required") {
			<app-check
				[disabled]="curRow.is_locked == 'yes' || curRow.public == 'yes'"
				(onClick)="changeYesNo(curRow, 'patient_sign_required', isNewRow)"
				[isCheck]="curRow.patient_sign_required == 'yes'"
			></app-check>
		}
		@case ("user_sign_required") {
			<app-check
				[disabled]="curRow.is_locked == 'yes' || curRow.public == 'yes'"
				(onClick)="changeYesNo(curRow, 'user_sign_required', isNewRow)"
				[isCheck]="curRow.user_sign_required == 'yes'"
			></app-check>
		}
		@case ("calculated") {
			<app-check
				[disabled]="curRow.is_locked == 'yes' || curRow.public == 'yes'"
				(onClick)="changeYesNo(curRow, 'calculated', isNewRow)"
				[isCheck]="curRow.calculated == 'yes'"
			></app-check>
		}
		@case ("is_locked") {
			<app-check
				[disabled]="!isNewRow"
				(onClick)="changeYesNo(curRow, 'is_locked', isNewRow)"
				[isCheck]="curRow.is_locked == 'yes'"
			></app-check>
		}
		@case ("flip") {
			@if (isNewRow) {
				<app-gen-select
					[actualObj]="curRow"
					hasNone
					title_ph_lang="test"
					fieldName="test_id"
					(changeEvent)="
						isNewRow ? validateEntireForm() : validateField(curRow, 'test_id')
					"
					[options]="topTestsForSelect"
				/>
			}
			@if (curRow.public !== "yes") {
				<app-spin-or-content [isSpin]="curRow.isFlipOrderSending">
					@if (!isNewRow && curRow.test_id && curRow.is_locked == "no") {
						<div class="up-down-wrapper">
							@if (!curRow.is_lowest_order) {
								<app-icon
									pointer
									icon="arrow_up"
									(click)="moveOrderNum(curRow, true)"
									title="forward"
								/>
							}
							@if (!curRow.is_highest_order) {
								<app-icon
									pointer
									icon="arrow_down"
									(click)="moveOrderNum(curRow, false)"
									title="backward"
								/>
							}
						</div>
					}
				</app-spin-or-content>
			}
		}
		@case ("questions") {
			@if (!isNewRow && !curRow?.tests?.length) {
				<button
					class="btn btn-icon"
					(click)="openQuestions(curRow)"
					titleLang="questions"
					icon="list"
				></button>
			}
		}
		@case ("active") {
			<app-check
				[disabled]="curRow.is_locked == 'yes' || curRow.public == 'yes'"
				(onClick)="changeYesNo(curRow, 'active', isNewRow)"
				[isCheck]="curRow.active == 'yes'"
			></app-check>
		}

		@case ("action") {
			@if (isNewRow) {
				<app-btn-ext
					text="add"
					(clickEv)="saveNewTest()"
					[disabled]="!isFormSubmittable"
					[isSpin]="isNewSaving"
				/>
			} @else {
				@if (!is_documented && curRow.public !== "yes") {
					<app-spin-or-content [isSpin]="curRow.isDeleting">
						<button
							class="btn btn-icon"
							(click)="modalProps = { name: 'confirm-delete', test: curRow }"
							titleLang="delete"
							icon="delete"
						></button>
					</app-spin-or-content>
				}
				@if (isTop && curRow.public !== "yes") {
					<app-spin-or-content [isSpin]="curRow.spinDup">
						<button
							class="btn btn-icon"
							(click)="duplicateTest(curRow)"
							titleLang="duplicate_test"
							icon="copy"
						></button>
					</app-spin-or-content>
				}
				@if (curRow.public !== "yes") {
					<button
						class="btn btn-icon"
						(click)="goToTestUpdate(curRow)"
						titleLang="update_test"
						[icon]="curRow.is_locked == 'yes' ? 'show' : 'edit'"
					></button>
				}
				<!--"is_documented?'show':-->
			}
		}
	}
</ng-template>

@switch (modalProps?.name) {
	@case ("update-test") {
		<app-modal-wrap
			(onClose)="modalProps = null; ngOnInit()"
			title="test"
			modalWrapperClass="modal-750"
		>
			<app-update-test
				(onClose)="modalProps = null; ngOnInit()"
				[test]="modalProps.test"
			/>
		</app-modal-wrap>
	}
	@case ("testquestions-manage") {
		<app-modal-wrap
			(onClose)="modalProps = null; updateTests()"
			title="questions"
			modalWrapperClass="modal-750"
		>
			<app-testquestions-manage
				(onClose)="modalProps = null; updateTests()"
				[test_id]="modalProps.test_id"
				[is_locked]="modalProps.is_locked"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-delete") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="do_you_confirm_delete"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="deleteTest($event)"
				[objectName]="modalProps.test.name"
			/>
		</app-modal-wrap>
	}
}
